import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui-kit/card';
import { Badge } from '@/components/ui-kit/badge';
import { PerformanceDashboard } from '../../types/dashboard.types';

export interface HeroSummaryProps {
  dashboard: PerformanceDashboard;
}

const StatTile = ({ label, value }: { label: string; value: number }) => (
  <div className="flex flex-1 flex-col items-center gap-1 rounded-md border p-4">
    <span className="text-2xl font-semibold text-primary">{value.toFixed(1)}</span>
    <span className="text-xs text-muted-foreground">{label}</span>
  </div>
);

export const HeroSummary = ({ dashboard }: HeroSummaryProps) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="min-w-0">
            <h2 className="text-lg font-semibold [overflow-wrap:anywhere]">{dashboard.EmployeeName}</h2>
            <p className="text-sm text-muted-foreground">
              {dashboard.Designation} {dashboard.DepartmentName ? `· ${dashboard.DepartmentName}` : ''}
            </p>
          </div>
          <Badge variant="info-subtle" className="max-w-full whitespace-normal [overflow-wrap:anywhere]">{t(dashboard.RatingBandLabel)}</Badge>
        </div>

        {dashboard.ReviewerGroupsSubmitted < dashboard.ReviewerGroupsTotal && (
          <p className="text-xs text-muted-foreground">
            {t('REVIEWER_GROUPS_SUBMITTED', {
              submitted: dashboard.ReviewerGroupsSubmitted,
              total: dashboard.ReviewerGroupsTotal,
            })}
          </p>
        )}

        <div className="flex flex-wrap gap-3">
          <StatTile label={t('FINAL_SCORE')} value={dashboard.FinalScore} />
          <StatTile label={t('QUALITATIVE_SCORE')} value={dashboard.QualitativeScore} />
          <StatTile label={t('QUANTITATIVE_SCORE')} value={dashboard.QuantitativeScore} />
        </div>
      </CardContent>
    </Card>
  );
};
